import { render, staticRenderFns } from "./AdminEditOrderSidebar.vue?vue&type=template&id=423db4ca&scoped=true&"
import script from "./AdminEditOrderSidebar.vue?vue&type=script&lang=ts&"
export * from "./AdminEditOrderSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423db4ca",
  null
  
)

export default component.exports